import { ActionTypes, IAction, IPageState } from './types';

export const InitialState: IPageState = {
  loading: false,
  isPaymentModalOpen: false,
  veiculos: {
    count: 0,
    offset: 0,
    records: [],
    pageSize: 20,
  },
};

export const Reducer = (state: IPageState, action: IAction): IPageState => {
  switch (action.type) {
    case ActionTypes.UPDATE_LOADING_STATUS:
      return {
        ...state,
        loading: action.payload?.status ?? false,
      };
    case ActionTypes.UPDATE_VEICULOS:
      return {
        ...state,
        loading: false,
        veiculos: action.payload?.veiculos ?? { ...InitialState.veiculos },
      };
    case ActionTypes.OPEN_PAYMENT_MODAL:
      return {
        ...state,
        isPaymentModalOpen: true,
      };
    case ActionTypes.UPDATE_PAYMENT_MODAL_STATUS:
      return {
        ...state,
        isPaymentModalOpen: action.payload.status ?? false,
      };
    case ActionTypes.CREATE_NEW_VEICULO:
      return {
        ...state,
        loading: false,
        isPaymentModalOpen: false,
      }
    default:
      return { ...state };
  }
};
